// @flow
import type { FullState } from '../../../types';

export const selectPreferencesDialogOpen = (state: FullState): boolean =>
  state.app.layout.preferencesDialogOpen;
